import React, { useEffect } from "react";
import "./Termsandconditions.css";
import { Helmet } from "react-helmet";
import ReactGA4 from "react-ga4";
import { useLocation } from "react-router-dom";
import CharterAccordian from "../components/Investor_Charter/CharterAccordian";
import InvestorComplaints from "./InvestorComplaints";
import PrivacyPolicy from "./PrivacyPolicy";
import Disclosure from "./Disclosure";
import PoliciesAndProcedures from "./PoliciesAndProcedures";
import TermsandConditions from "./TermsandConditions";
import Table from "../components/common/Table/Table";
import RiskDisclosure from "./RiskDisclosure";
import {
  Account_Closure_Form,
  Demat_Debit_and_Pledge_Instruction,
  Dematerialisation_Request_Form,
  DIS_Request_Form,
  Dormant_Account_Reactivation_Form,
  Freeze_Unfreeze_Request_Form,
  Invocation_Request_Form,
  KYC_Form,
  KRA_Form,
  Margin_Invocation_Request_Form,
  Margin_Pledge_Request_Form,
  Margin_Un_pledge_Request_Form,
  Nomination_Form,
  Nomination_Opting_Out_Declaration_form,
  Pledge_Request_Form,
  Rejection_Letter_for_Dematerialisation_Request_Number_DRN,
  Rejection_Letter_for_Dematerialisation_Request_Number_DRN_BO_TO_DP,
  Trading_Demat_Account_Details_Addition_Modification_Form,
  Transmission_cum_Dematerialisation,
  Transmission_Form_Sole_Holder,
  Transmission_With_and_Without_Nominee,
  Transposition_Request_Form,
  Unpledge_Request_Form,
} from "../assets/forms_and_applications";
import { Bank_Details, Investor_Charter_DP } from "../assets/fabits_assets";

const tableData = [
  {
    id: 1,
    title: "Nomination Form",
    pdf: Nomination_Form,
  },
  {
    id: 2,
    title: "Nomination Opting Out Declaration form",
    pdf: Nomination_Opting_Out_Declaration_form,
  },
  {
    id: 3,
    title: "KRA Form",
    pdf: KYC_Form,
  },
  {
    id: 4,
    title: "Pledge Request Form",
    pdf: Pledge_Request_Form,
  },
  {
    id: 5,
    title: "Un-pledge Request Form",
    pdf: Unpledge_Request_Form,
  },
  {
    id: 6,
    title: "Demat Debit and Pledge Instruction (DDPI)",
    pdf: Demat_Debit_and_Pledge_Instruction,
  },
  {
    id: 7,
    title: "Freeze-Unfreeze Request Form",
    pdf: Freeze_Unfreeze_Request_Form,
  },
  {
    id: 8,
    title: "Invocation Request Form (IRF)",
    pdf: Invocation_Request_Form,
  },
  {
    id: 9,
    title: "Margin Pledge Request Form",
    pdf: Margin_Pledge_Request_Form,
  },
  {
    id: 10,
    title: "Margin Invocation Request Form",
    pdf: Margin_Invocation_Request_Form,
  },
  {
    id: 11,
    title: "Margin Un-pledge Request Form",
    pdf: Margin_Un_pledge_Request_Form,
  },
  {
    id: 12,
    title: "Trading / Demat Account Details Addition / Modification Form",
    pdf: Trading_Demat_Account_Details_Addition_Modification_Form,
  },
  {
    id: 13,
    title: "Individual Account Opening Form ",
    pdf: "https://s3.ap-south-1.amazonaws.com/liquide.money/uploads/broking-life/forms/Individual%20Account%20Opening%20Form.pdf",
  },
  {
    id: 14,
    title: "NRI Account Opening Form",
    pdf: "https://s3.ap-south-1.amazonaws.com/liquide.money/uploads/broking-life/forms/NRI%20Account%20Opening%20Form.pdf",
  },
  {
    id: 15,
    title: "Non-Individual Account Opening Form",
    pdf: "https://s3.ap-south-1.amazonaws.com/liquide.money/uploads/broking-life/Corporate_AOF.pdf",
  },
  {
    id: 16,
    title: "DIS Request Form ",
    pdf: DIS_Request_Form,
  },
  {
    id: 17,
    title: "Dematerialisation Request Form",
    pdf: Dematerialisation_Request_Form,
  },
  {
    id: 18,
    title: "Transposition Request Form",
    pdf: Transposition_Request_Form,
  },
  {
    id: 19,
    title: "Transmission cum Dematerialisation",
    pdf: Transmission_cum_Dematerialisation,
  },
  {
    id: 20,
    title: "Transmission Form Sole Holder",
    pdf: Transmission_Form_Sole_Holder,
  },
  {
    id: 21,
    title: "Transmission With and Without Nominee",
    pdf: Transmission_With_and_Without_Nominee,
  },
  {
    id: 22,
    title: "Dormant Account Reactivation Form",
    pdf: Dormant_Account_Reactivation_Form,
  },
  {
    id: 23,
    title: "Account Closer Form",
    pdf: Account_Closure_Form,
  },
  {
    id: 24,
    title: "Rejection Letter for Dematerialisation Request Number (DRN)",
    pdf: Rejection_Letter_for_Dematerialisation_Request_Number_DRN,
  },
  {
    id: 25,
    title:
      "Rejection Letter for Dematerialisation Request Number (DRN) (BO-to-DP)",
    pdf: Rejection_Letter_for_Dematerialisation_Request_Number_DRN_BO_TO_DP,
  },
  {
    id: 26,
    title: "FATCA",
    pdf: "https://s3.ap-south-1.amazonaws.com/liquide.money/uploads/broking-life/forms/FATCA.pdf",
  },
  {
    id: 27,
    title: "SARAL FORM",
    pdf: "https://s3.ap-south-1.amazonaws.com/liquide.money/uploads/broking-life/ANNEX_A-SARAL_AOF_p.pdf",
  },

  // {
  //   id: 28,
  //   title: "KRA Form",
  //   pdf: KRA_Form,
  // },
];

const Data = [
  {
    id: 1,
    title: <span>INVESTOR CHARTER - STOCK BROKERS</span>,
    content: (
      <>
        <div classNameName="contentstartshere">
          <h2 style={{ marginTop: "20px" }}>VISION</h2>

          <p className="mt-5">
            To follow highest standards of ethics and compliances while
            facilitating the trading by clients in securities in a fair and
            transparent manner, so as to contribute in creation of wealth for
            investors.
          </p>

          <h3 className="heeding3standcpage">MISSION</h3>
          <ol className="olol">
            <li>
              To provide high quality and dependable service through innovation,
              capacity enhancement and use of technology.
            </li>
            <li>
              To establish and maintain a relationship of trust and ethics with
              the investors.
            </li>
            <li>
              To observe highest standard of compliances and transparency.
            </li>
            <li>
              To always keep ‘protection of investors’ interest’ as goal while
              providing service.
            </li>
            <li>
              To ensure confidentiality of information shared by investors
              unless such information is required to be provided in furtherance
              of discharging legal obligations or investors have provided
              specific consent to share such information.
            </li>
          </ol>
          <h3 className="heeding3standcpage">
            Services provided to Investors by stockbrokers include
          </h3>
          <ol className="olol">
            <li>Execution of trades on behalf of investors.</li>
            <li>Issuance of Contract Notes.</li>
            <li>Issuance of intimations regarding margin due payments.</li>
            <li>
              Facilitate execution of early pay-in obligation instructions.
            </li>
            <li>Periodic Settlement of client’s funds.</li>
            <li>
              Issuance of retention statement of funds at the time of
              settlement.
            </li>
            <li>
              Risk management systems to mitigate operational and market risk.
            </li>
            <li>
              Facilitate client profile changes in the system as instructed by
              the client.
            </li>
            <li>
              Information sharing with the client w.r.t. relevant Market
              Infrastructure Institutions (MII) circulars.
            </li>
            <li>
              Provide a copy of Rights &amp; Obligations document to the client.
            </li>
            <li>
              Communicating Most Important terms and Conditions (MITC) to the
              client.
            </li>
            <li>Redressal of Investor’s grievances.</li>
          </ol>
          <h3 className="heeding3standcpage">Rights of Investors</h3>
          <ol className="olol">
            <li>
              Ask for and receive information from a firm about the work history
              and background of the person handling your account, as well as
              information about the firm itself (including website providing
              mandatory information).
            </li>
            <li>
              Receive complete information about the risks, obligations, and
              costs of any investment before investing.
            </li>
            <li>
              Receive a copy of all completed account forms and rights &amp;
              obligation document.
            </li>
            <li>
              Receive a copy of ‘Most Important Terms &amp; Conditions’ (MITC).
            </li>
            <li>
              Receive account statements that are accurate and understandable.
            </li>
            <li>
              Understand the terms and conditions of transactions you undertake.
            </li>
            <li>
              Access your funds in a prescribed manner and receive information
              about any restrictions or limitations on access.
            </li>
            <li>
              Receive complete information about maintenance or service charges,
              transaction or redemption fees, and penalties in form of tariff
              sheet.
            </li>
            <li>
              Discuss your grievances with compliance officer / compliance team
              / dedicated grievance redressal team of the firm and receive
              prompt attention to and fair consideration of your concerns.
            </li>
            <li>
              Close your zero balance accounts online with minimal documentation
            </li>
            <li>
              Get the copies of all policies (including Most Important Terms and
              Conditions) of the broker related to dealings of your account
            </li>
            <li>
              Not be discriminated against in terms of services offered to
              equivalent clients
            </li>
            <li>
              Get only those advertisement materials from the broker which
              adhere to Code of Advertisement norms in place
            </li>
            <li>
              In case of broker defaults, be compensated from the Exchange
              Investor Protection Fund as per the norms in place
            </li>
            <li>
              Trade in derivatives after submission of relevant financial
              documents to the broker subject to brokers’ adequate due
              diligence.
            </li>
            <li>
              Get warnings on the trading systems while placing orders in
              securities where surveillance measures are in place
            </li>
            <li>
              Get access to products and services in a suitable manner even if
              differently abled
            </li>
            <li>Get access to educational materials of the MIIs and brokers</li>
            <li>
              Get access to all the exchanges of a particular segment you wish
              to deal with unless opted out specifically as per Broker norms
            </li>
            <li>
              Deal with one or more stockbrokers of your choice without any
              compulsion of minimum business
            </li>
            <li>
              Have access to the escalation matrix for communication with the
              broker
            </li>
            <li>
              Not be bound by any clause prescribed by the Brokers which are
              contravening the Regulatory provisions.
            </li>
          </ol>
          <h3 className="heeding3standcpage">
            Various activities of Stock Brokers with timelines
          </h3>
          <table className="table-investorcharter">
            <thead>
              <tr>
                <th className="row th p-3 col-6">Activities</th>
                <th className="row th p-3 col-6">Expected Timelines</th>
              </tr>
            </thead>
            <tbody>
              <tr className="p-1 py-2 bg-light">
                <td className="col-6">KYC entered into KRA System and CKYCR</td>
                <td className="col-6">3 working days of account opening</td>
              </tr>
              <tr className="p-1 py-2">
                <td className="col-6">Client Onboarding</td>
                <td className="col-6">
                  Immediate, but not later than one week
                </td>
              </tr>
              <tr className="p-1 py-2 bg-light">
                <td className="col-6">Order execution</td>
                <td className="col-6">
                  Immediate on receipt of order, but not later than the same day
                </td>
              </tr>
              <tr className="p-1 py-2">
                <td className="col-6">Allocation of Unique Client Code</td>
                <td className="col-6">Before trading</td>
              </tr>
              <tr className="p-1 py-2 bg-light">
                <td className="col-6">
                  Copy of duly completed Client Registration Documents to
                  clients
                </td>
                <td className="col-6">
                  7 days from the date of upload of Unique Client Code to the
                  Exchange by the trading member
                </td>
              </tr>
              <tr className="p-1 py-2">
                <td className="col-6">Issuance of contract notes</td>
                <td className="col-6">24 hours of execution of trades</td>
              </tr>
              <tr className="p-1 py-2 bg-light">
                <td className="col-6">
                  Collection of upfront margin from client
                </td>
                <td className="col-6">Before initiation of trade</td>
              </tr>
              <tr className="p-1 py-2">
                <td className="col-6">
                  Issuance of intimations regarding other margin due payments
                </td>
                <td className="col-6">At the end of the T day</td>
              </tr>
              <tr className="p-1 py-2 bg-light">
                <td className="col-6">Settlement of client funds</td>
                <td className="col-6">
                  First Friday/Saturday of the month / quarter as per Exchange
                  pre-announced schedule
                </td>
              </tr>
              <tr className="p-1 py-2">
                <td className="col-6">
                  ‘Statement of Accounts’ for Funds, Securities and Commodities
                </td>
                <td className="col-6">Monthly basis</td>
              </tr>
              <tr className="p-1 py-2 bg-light">
                <td className="col-6">
                  Issuance of retention statement of funds/commodities
                </td>
                <td className="col-6">5 days from the date of settlement</td>
              </tr>
              <tr className="p-1 py-2">
                <td className="col-6">Issuance of Annual Global Statement</td>
                <td className="col-6">
                  30 days from the end of the financial year
                </td>
              </tr>
              <tr className="p-1 py-2 bg-light">
                <td className="col-6">Investor grievances redressal</td>
                <td className="col-6">
                  21 calendar days from the receipt of the complaint
                </td>
              </tr>
            </tbody>
          </table>
          <h3 className="heeding3standcpage">DOs and DON’Ts for Investors</h3>
          <table className="table-investorcharter">
            <thead>
              <tr>
                <th className="row th p-3 col-6">DOs</th>
                <th className="row th p-3 col-6">DON’Ts</th>
              </tr>
            </thead>
            <tbody>
              <tr className="p-1 py-2 ">
                <td className="col-6">
                  <ol className="olol">
                    <li>
                      Read all documents and conditions being agreed before
                      signing the account opening form.
                    </li>
                    <li>
                      Receive a copy of KYC, copy of account opening documents
                      and Unique Client Code.
                    </li>
                    <li>
                      Read the product / operational framework / timelines
                      related to various Trading and Clearing &amp; Settlement
                      processes.
                    </li>
                    <li>
                      Receive all information about brokerage, fees and other
                      charges levied.
                    </li>
                    <li>
                      Register your mobile number and email ID in your trading,
                      demat and bank accounts to get regular alerts on your
                      transactions.
                    </li>
                    <li>
                      If executed, receive a copy of Demat Debit and Pledge
                      Instruction (DDPI) However, DDPI is not a mandatory
                      requirement as per SEBI / Stock Exchanges. Before granting
                      DDPI, carefully examine the scope and implications of
                      powers being granted.
                    </li>
                    <li>
                      Receive contract notes for trades executed, showing
                      transaction price, brokerage, GST and STT/CTT etc. as
                      applicable, separately, within 24 hours of execution of
                      trades.
                    </li>
                    <li>
                      Receive funds and securities/ commodities on time, as
                      prescribed by SEBI or exchange from time to time.
                    </li>
                    <li>
                      Verify details of trades, contract notes and statement of
                      account and approach relevant authority for any
                      discrepancies. Verify trade details on the Exchange
                      websites from the trade verification facility provided by
                      the Exchanges.
                    </li>
                    <li>
                      Receive statement of accounts periodically. If opted for
                      running account settlement, account has to be settled by
                      the stock broker as per the option given by the client
                      (Monthly or Quarterly).
                    </li>
                    <li>
                      In case of any grievances, approach stock broker or Stock
                      Exchange or SEBI for getting the same resolved within
                      prescribed timelines.
                    </li>
                    <li>
                      Retain documents for trading activity as it helps in
                      resolving disputes, if they arise.
                    </li>
                  </ol>
                </td>
                <td className="col-6">
                  <ol className="olol">
                    <li>Do not deal with unregistered stock broker.</li>
                    <li>
                      Do not forget to strike off blanks in your account opening
                      and KYC.
                    </li>
                    <li>
                      Do not submit an incomplete account opening and KYC form.
                    </li>
                    <li>
                      Do not forget to inform any change in information linked
                      to trading account and obtain confirmation of updation in
                      the system.
                    </li>
                    <li>
                      Do not transfer funds, for the purposes of trading to
                      anyone other than a stock broker. No payment should be
                      made in name of employee of stock broker.
                    </li>
                    <li>
                      Do not ignore any emails / SMSs received with regards to
                      trades done, from the Stock Exchange and raise a concern,
                      if discrepancy is observed.
                    </li>
                    <li>
                      Do not opt for digital contracts, if not familiar with
                      computers.
                    </li>
                    <li>Do not share trading password.</li>
                    <li>
                      Do not fall prey to fixed / guaranteed returns schemes.
                    </li>
                    <li>
                      Do not fall prey to fraudsters sending emails and SMSs
                      luring to trade in stocks / securities promising huge
                      profits.
                    </li>
                    <li>
                      Do not follow herd mentality for investments. Seek expert
                      and professional advice for your investments
                    </li>
                  </ol>
                </td>
              </tr>
            </tbody>
          </table>
          <p className="mt-3">
            Additionally, Investors may refer to Dos and Don’ts issued by MIIs
            on their respective websites from time to time.
          </p>
          <h3 className="mt-4">Grievance Redressal Mechanism</h3>
          <p className="mt-3">
            The process of investor grievance redressal is as follows:
          </p>
          <table className="table-investorcharter">
            <thead>
              <tr>
                <th className="row th p-3 col-6">Step</th>
                <th className="row th p-3 col-6">Details</th>
              </tr>
            </thead>
            <tbody>
              <tr className="p-1 py-2 ">
                <td className="col-6">1. Investor complaint/Grievances</td>
                <td className="col-6">
                  <p>
                    Investor can lodge complaint/grievance against stock broker
                    in the following ways:
                  </p>
                  <p>
                    <u>Mode of filing the complaint with stock broker</u>
                  </p>
                  <p>
                    Investor can approach the Stock Broker at the designated
                    Investor Grievance e-mail ID of the stock broker. The Stock
                    Broker will strive to redress the grievance immediately, but
                    not later than 21 days of the receipt of the grievance
                  </p>
                  <p>
                    <u>Mode of filing the complaint with stock exchanges</u>
                  </p>
                  <ol className="olol" type="i">
                    <li>
                      SCORES 2.0 (a web based centralized grievance redressal
                      system of SEBI) (
                      <a href="https://scores.sebi.gov.in">
                        https://scores.sebi.gov.in
                      </a>
                      )
                      <p>
                        <u>
                          Two level review for complaint/grievance against stock
                          broker:
                        </u>
                      </p>
                      <ul>
                        <li>First review done by Designated body/Exchange</li>
                        <li>Second review done by SEBI</li>
                      </ul>
                    </li>
                    <li>Emails to designated email IDs of Exchange</li>
                  </ol>
                </td>
              </tr>
              <tr className="p-1 py-2">
                <td className="col-6">
                  2. Online Dispute Resolution (ODR) platform for online
                  Conciliation and Arbitration
                </td>
                <td className="col-6">
                  If the Investor is not satisfied with the resolution provided
                  by the Market Participants, then the Investor has the option
                  to file the complaint/ grievance on SMARTODR platform for its
                  resolution through online conciliation or arbitration.
                </td>
              </tr>
              <tr className="p-1 py-2 ">
                <td className="col-6">
                  3. Steps to be followed in ODR for Review, Conciliation and
                  Arbitration
                </td>
                <td className="col-6">
                  <ol className="olol">
                    <li>
                      Investor to approach Market Participant for redressal of
                      complaint
                    </li>
                    <li>
                      If investor is not satisfied with response of Market
                      Participant, he/she has either of the following 2 options:
                      <ol className="olol" type="i">
                        <li>
                          May escalate the complaint on SEBI SCORES portal.
                        </li>
                        <li>
                          May also file a complaint on SMARTODR portal for its
                          resolution through online conciliation and
                          arbitration.
                        </li>
                      </ol>
                    </li>
                    <li>
                      Upon receipt of complaint on SMARTODR portal, the relevant
                      MII will review the matter and endeavor to resolve the
                      matter between the Market Participant and investor within
                      21 days.
                    </li>
                    <li>
                      If the matter could not be amicably resolved, then the
                      matter shall be referred for conciliation.
                    </li>
                    <li>
                      During the conciliation process, the conciliator will
                      endeavor for amicable settlement of the dispute within 21
                      days, which may be extended with 10 days by the
                      conciliator with consent of the parties to dispute.
                    </li>
                    <li>
                      If the conciliation is unsuccessful, then the investor may
                      request to refer the matter for arbitration.
                    </li>
                    <li>
                      The arbitration process to be concluded by arbitrator(s)
                      within 30 days, which is extendable by 30 days with
                      consent of the parties to dispute.
                    </li>
                  </ol>
                </td>
              </tr>
            </tbody>
          </table>
          <h3 className="heeding3standcpage">
            Handling of Investor’s claims / complaints in case of default of a
            Trading Member / Clearing Member (TM/CM)
          </h3>
          <h3 className="heeding3standcpage">Default of TM/CM</h3>
          <p className="mt-5">
            Following steps are carried out by Stock Exchange for benefit of
            investor, in case stock broker defaults:
          </p>
          <ol className="olol">
            <li>
              Circular is issued to inform about declaration of Stock Broker as
              Defaulter.
            </li>
            <li>
              Information of defaulter stock broker is disseminated on Stock
              Exchange website.
            </li>
            <li>
              Public Notice is issued informing declaration of a stock broker as
              defaulter and inviting claims within specified period.
            </li>
            <li>
              Intimation to clients of defaulter stock brokers via emails and
              SMS for facilitating lodging of claims within the specified
              period.
            </li>
          </ol>
          <p className="mt-5">
            Following information is available on Stock Exchange website for
            information of investors:
          </p>
          <ol className="olol">
            <li>Norms for eligibility of claims for compensation from IPF.</li>
            <li>
              Claim form for lodging claim against defaulter stock broker.
            </li>
            <li>
              FAQ on processing of investors’ claims against Defaulter stock
              broker.
            </li>
            <li>Provision to check online status of client’s claim.</li>
            <li>
              Standard Operating Procedure (SOP) for handling of Claims of
              Investors in the Cases of Default by Brokers
            </li>
            <li>Claim processing policy against Defaulter/Expelled members</li>
            <li>List of Defaulter/Expelled members and public notice issued</li>
          </ol>
        </div>
      </>
    ),
  },
  {
    id: 2,
    title: (
      <span>
        INVESTOR CHARTER FOR DEPOSITORIES AND DEPOSITORY PARTICIPANTS (Annexure
        – A)
      </span>
    ),
    content: (
      // <>
      //   <h3 className="heeding3standcpage">Vision</h3>

      //   <p className="mt-5">
      //     Towards making the Indian Securities Market – Transparent, Efficient,
      //     & Investor friendly by providing safe, reliable, transparent and
      //     trusted record keeping platform for investors to hold and transfer
      //     securities in dematerialized form
      //   </p>

      //   <h3 className="heeding3standcpage">Mission</h3>

      //   <ol className="olol">
      //     <li>
      //       To hold securities of investors in dematerialized form and
      //       facilitate its transfer, while ensuring safekeeping of securities
      //       and protecting interest of investors.
      //     </li>
      //     <li>
      //       To provide timely and accurate information to investors with regard
      //       to their holding and transfer of securities held by them.
      //     </li>
      //     <li>
      //       To provide the highest standards of investor education, investor
      //       awareness and timely services so as to enhance Investor Protection
      //       and create awareness about Investor Rights.
      //     </li>
      //   </ol>

      //   <h3 className="heeding3standcpage">
      //     Details of business transacted by the Depository and Depository
      //     Participant (DP)
      //   </h3>

      //   <p className="mt-5">
      //     A Depository is an organization which holds securities of investors in
      //     electronic form. Depositories provide services to various market
      //     participants – Exchanges, Clearing Corporations, Depository
      //     Participants (DPs), Issuers, and Investors in both primary as well as
      //     secondary markets. The depository carries out its activities through
      //     its agents which are known as Depository Participants (DP). Details
      //     are available on the link
      //     <a href="https://www.cdslindia.com/DP/dplist.aspx">
      //       [https://www.cdslindia.com/DP/dplist.aspx].
      //     </a>
      //   </p>

      //   <h3 className="heeding3standcpage">
      //     Description of services provided by the Depository through Depository
      //     Participants (DPs) to investors
      //   </h3>

      //   <p className="mt-5">(1) Basic Services</p>
      //   <table className="table-investorcharter">
      //     <thead>
      //       <tr>
      //         <th className="row th p-3 col-6">
      //           Brief about the Activity / Service
      //         </th>
      //         <th className="row th p-3 col-6">
      //           Expected Timelines for processing by the DP after receipt of
      //           proper documents
      //         </th>
      //       </tr>
      //     </thead>
      //     <tbody>
      //       <tr className="p-1 py-2 bg-light">
      //         <td className="col-6">Dematerialization of securities</td>
      //         <td className="col-6">7 days</td>
      //       </tr>
      //       <tr className="p-1 py-2">
      //         <td className="col-6">Rematerialization of securities</td>
      //         <td className="col-6">7 days</td>
      //       </tr>
      //       <tr className="p-1 py-2 bg-light">
      //         <td className="col-6">
      //           Mutual Fund Conversion / Destatementization
      //         </td>
      //         <td className="col-6">5 days</td>
      //       </tr>
      //       <tr className="p-1 py-2">
      //         <td className="col-6">
      //           Re-conversion / Restatementisation of Mutual fund units
      //         </td>
      //         <td className="col-6">7 days</td>
      //       </tr>
      //       <tr className="p-1 py-2 bg-light">
      //         <td className="col-6">Transmission of securities</td>
      //         <td className="col-6">7 days</td>
      //       </tr>
      //       <tr className="p-1 py-2">
      //         <td className="col-6">Registering pledge request</td>
      //         <td className="col-6">15 days</td>
      //       </tr>
      //       <tr className="p-1 py-2 bg-light">
      //         <td className="col-6">Closure of demat account</td>
      //         <td className="col-6">30 days</td>
      //       </tr>
      //       <tr className="p-1 py-2">
      //         <td className="col-6">Settlement Instruction</td>
      //         <td className="col-6">
      //           Depositories to accept physical DIS for pay-in of securities up
      //           to 4 p.m. and DIS in electronic form up to 6 p.m. on T+1 day
      //         </td>
      //       </tr>
      //     </tbody>
      //   </table>
      //   <p className="mt-5">
      //     (2) Depositories provide special services like pledge, hypothecation,
      //     internet-based services etc. in addition to their core services and
      //     these include
      //   </p>
      //   <table className="table-investorcharter">
      //     <thead>
      //       <tr>
      //         <th className="row th p-3 col-6">Type of Activity / Service</th>
      //         <th className="row th p-3 col-6">
      //           Brief about the Activity / Service
      //         </th>
      //       </tr>
      //     </thead>
      //     <tbody>
      //       <tr className="p-1 py-2 bg-light">
      //         <td className="col-6">Value Added Services</td>
      //         <td className="col-6">
      //           Depositories also provide value added services such as
      //           <br />
      //           <a href="https://www.cdslindia.com/Investors/InvestorCharter.html">
      //             a. Basic Services Demat Account (BSDA)
      //           </a>
      //           <br />
      //           <a href="https://www.cdslindia.com/Investors/InvestorCharter.html">
      //             b. Transposition cum dematerialization
      //           </a>
      //           <br />
      //           <a href="https://www.cdslindia.com/Investors/InvestorCharter.html">
      //             c. Linkages with Clearing System
      //           </a>
      //           <br />
      //           <p className="mt-5">
      //             d. Distribution of cash and non-cash corporate benefits
      //             (Bonus, Rights, IPOs etc.), stock lending.
      //           </p>
      //         </td>
      //       </tr>
      //       <tr className="p-1 py-2">
      //         <td className="col-6">Consolidated Account statement (CAS)</td>
      //         <td className="col-6">
      //           CAS is issued 10 days from the end of the month (if there were
      //           transactions in the previous month) or half yearly(if no
      //           transactions) .
      //         </td>
      //       </tr>
      //       <tr className="p-1 py-2 bg-light">
      //         <td className="col-6">
      //           Digitalization of provided services by the depositories
      //         </td>
      //         <td className="col-6">
      //           Depositories offer below technology solutions and e-facilities
      //           to their demat account holders through DPs:
      //           <ol className="olol">
      //             <li>
      //               E-account opening: Details available on the{" "}
      //               <a href="https://www.cdslindia.com/Investors/InvestorCharter.html">
      //                 link
      //               </a>
      //             </li>
      //             <li>
      //               Online instructions for execution: Details available on the{" "}
      //               <a href="https://www.cdslindia.com/Investors/InvestorCharter.html">
      //                 link
      //               </a>
      //               <ul>
      //                 <li>
      //                   <a href="https://www.cdslindia.com/Investors/InvestorCharter.html">
      //                     Easiest
      //                   </a>
      //                 </li>
      //                 <li>
      //                   <a href="https://www.cdslindia.com/Investors/InvestorCharter.html">
      //                     Gift transfers
      //                   </a>
      //                 </li>
      //               </ul>
      //             </li>
      //             <li>
      //               e-DIS / Demat Gateway: Details available on the{" "}
      //               <a href="https://www.cdslindia.com/Investors/InvestorCharter.html">
      //                 link
      //               </a>
      //             </li>
      //             <li>
      //               e-CAS facility: Details available on the{" "}
      //               <a href="https://www.cdslindia.com/Investors/InvestorCharter.html">
      //                 link
      //               </a>
      //             </li>
      //             <li>
      //               Miscellaneous services: Details available on the{" "}
      //               <a href="https://www.cdslindia.com/Investors/InvestorCharter.html">
      //                 link
      //               </a>
      //             </li>
      //           </ol>
      //         </td>
      //       </tr>
      //     </tbody>
      //   </table>
      //   <h2>Details of Grievance Redressal Mechanism</h2>

      //   <p className="mt-5">The Process of investor grievance redressal</p>
      //   <table className="table-investorcharter">
      //     <tbody>
      //       <tr className="row p-1 py-2">
      //         <td className="col-6">Investor Complaint/ Grievances</td>
      //         <td className="col-6">
      //           <p className="mt-5">
      //             Investor can lodge complaint/ grievance against the
      //             Depository/DP in the following ways:
      //           </p>
      //           <ol className="olol">
      //             <li>Electronic mode -</li>
      //             <li>
      //               <a href="https://www.scores.gov.in/scores/Welcome.html">
      //                 SCORES
      //               </a>{" "}
      //               (a web-based centralized grievance redressal system of SEBI)
      //               <ul className="ulul">
      //                 <li className="justify">
      //                   Respective Depository’s web portal dedicated for the
      //                   filing of complaint
      //                 </li>
      //               </ul>
      //             </li>
      //             <li>
      //               Offline mode [details of link to the form to be provided by
      //               DPs]
      //             </li>
      //           </ol>
      //           <p className="mt-5">
      //             The complaints/ grievances lodged directly with the Depository
      //             shall be resolved within 30 days.
      //           </p>
      //         </td>
      //       </tr>
      //       <tr className="row p-1 py-2 bg-light">
      //         <td className="col-6">
      //           Investor Grievance Redressal Committee of Depository
      //         </td>
      //         <td className="col-6">
      //           If no amicable resolution is arrived, then the Investor has the
      //           option to refer the complaint/grievance to the Grievance
      //           Redressal Committee (GRC) of the Depository. Upon receipt of
      //           reference, the GRC will endeavor to resolve the complaint/
      //           grievance by hearing the parties and examining the necessary
      //           information and documents.
      //         </td>
      //       </tr>
      //       <tr className="row p-1 py-2">
      //         <td className="col-6">Arbitration proceedings</td>
      //         <td className="col-6">
      //           The Investor may also avail the arbitration mechanism set out in
      //           the Byelaws and Business Rules/Operating Instructions of the
      //           Depository in relation to any grievance, or dispute relating to
      //           depository services. The arbitration reference shall be
      //           concluded by way of issue of an arbitral award within 4 months
      //           from the date of appointment of arbitrator(s).
      //         </td>
      //       </tr>
      //     </tbody>
      //   </table>
      //   <p className="mt-5">
      //     For the Multi-level complaint resolution mechanism available at the
      //     Depositories please refer to
      //     <a href="https://www.cdslindia.com/Investors/InvestorCharter.html">
      //       link.
      //     </a>
      //   </p>

      //   <h2>
      //     Guidance pertaining to special circumstances related to market
      //     activities: Termination of the Depository Participant
      //   </h2>

      //   <table className="table-investorcharter">
      //     <tbody>
      //       <tr className="row p-3">
      //         <td className="col-6">
      //           <b>Type of special circumstances</b>
      //         </td>
      //         <td className="col-6">
      //           <b>Timelines for the Activity/ Service</b>
      //         </td>
      //       </tr>
      //       <tr className="p-3">
      //         <td className="col-6">
      //           <ol className="olol">
      //             <li>
      //               Depositories to terminate the participation in case a
      //               participant no longer meets the eligibility criteria and/or
      //               any other grounds as mentioned in the bye laws like
      //               suspension of trading member by the Stock Exchanges.
      //             </li>
      //             <li>
      //               Participant surrenders the participation by its own wish.
      //             </li>
      //           </ol>
      //         </td>
      //         <td className="col-6">
      //           Client will have a right to transfer all its securities to any
      //           other Participant of its choice without any charges for the
      //           transfer within 30 days from the date of intimation by way of
      //           letter/email.
      //         </td>
      //       </tr>
      //     </tbody>
      //   </table>

      // </>
      <div style={{ marginTop: "20px" }}>
        <a
          href={Investor_Charter_DP}
          target="_blank"
          style={{ color: "black", fontWeight: "bold" }}
          rel="noreferrer"
        >
          Click Here To Download
        </a>
      </div>
    ),
  },
];

const compData = [
  {
    id: 1,
    title: "Complaints",
    content: (
      <>
        <InvestorComplaints />
      </>
    ),
  },
];

const privacyData = [
  {
    id: 1,
    title: "Privacy Policy",
    content: (
      <>
        <PrivacyPolicy />
      </>
    ),
  },
];

const discData = [
  {
    id: 1,
    title: "Disclosure",
    content: (
      <>
        <Disclosure />
      </>
    ),
  },
];

const policyData = [
  {
    id: 1,
    title: "Policies and Procedures",
    content: (
      <>
        <PoliciesAndProcedures />
      </>
    ),
  },
];

const TandCData = [
  {
    id: 1,
    title: "Terms and Conditions",
    content: (
      <>
        <TermsandConditions />
      </>
    ),
  },
];

const BankDetailsTandCData = [
  {
    id: 1,
    title: "Bank Details",
    content: (
      <div style={{ marginTop: "20px" }}>
        <a
          href={Bank_Details}
          target="_blank"
          style={{ color: "black", fontWeight: "bold" }}
          rel="noreferrer"
        >
          Click Here To Download
        </a>
      </div>
    ),
  },
];

const policiesData = [
  {
    id: 1,
    title: "Application Forms",
    content: (
      <>
        <Table tableData={tableData} />
      </>
    ),
  },
];

const riskData = [
  {
    id: 1,
    title: "Risk Disclosure On Derivatives",
    content: (
      <>
        <RiskDisclosure />
      </>
    ),
  },
];

function InvestorCharter() {
  const location = useLocation();
  useEffect(() => {
    ReactGA4.send("pageview", location.pathname);
  }, [location.pathname]);

  return (
    <>
      <div className="termsandconditionspage">
        <Helmet>
          <title>Broking Life</title>
          <meta
            name="description"
            content="New Age AI Broker"
          />
        </Helmet>
        {/* Investor's Portal */}
        <div>
          <h1 style={{ fontSize: "2em", margin: "20px 0px 0px 0px" }}>
            1. Investor's Portal
          </h1>
          <CharterAccordian Data={Data} />
        </div>
        {/* Investor Complaints */}
        <div>
          <h1 style={{ fontSize: "2em", margin: "30px 0px 0px 0px" }}>
            2. Investor Complaints
          </h1>
          <CharterAccordian Data={compData} />
        </div>
        {/* Privacy */}
        <div>
          <h1 style={{ fontSize: "2em", margin: "30px 0px 0px 0px" }}>
            3. Privacy
          </h1>
          <CharterAccordian Data={privacyData} />
        </div>
        {/* Disclosure */}
        <div>
          <h1 style={{ fontSize: "2em", margin: "30px 0px 0px 0px" }}>
            4. Disclosure
          </h1>
          <CharterAccordian Data={discData} />
        </div>

        {/* Policies and Procedures */}
        <div>
          <h1 style={{ fontSize: "2em", margin: "30px 0px 0px 0px" }}>
            5. Policies and Procedures
          </h1>
          <CharterAccordian Data={policyData} />
        </div>

        {/* Terms and Conditions  */}
        <div>
          <h1 style={{ fontSize: "2em", margin: "30px 0px 0px 0px" }}>
            6. Terms and Conditions
          </h1>
          <CharterAccordian Data={TandCData} />
        </div>

        {/* Bank Details */}
        <div>
          <h1 style={{ fontSize: "2em", margin: "30px 0px 0px 0px" }}>
            7. Bank Details
          </h1>
          <CharterAccordian Data={BankDetailsTandCData} />
        </div>

        {/* Downloads  */}
        <div>
          <h1 style={{ fontSize: "2em", margin: "30px 0px 0px 0px" }}>
            8. Application Forms
          </h1>
          <CharterAccordian Data={policiesData} />
        </div>

        {/* Risks  */}
        <div>
          <h1 style={{ fontSize: "2em", margin: "30px 0px 0px 0px" }}>
            9. Risks
          </h1>
          <CharterAccordian Data={riskData} />
        </div>
      </div>
    </>
  );
}

export default InvestorCharter;
